// superadmin her role dahildir
export const SA = 'superadmin';

export function rolde(kullanici, ...roller) {
  if (!kullanici) return false;
  if (kullanici.rol === SA) return true;
  return roller.includes(kullanici.rol);
}
